// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SourcesStackItem from './SourcesStackItem';
// css
import '../../styles/containers/SourcesStack.scss';


class SourcesStack extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSubArea: -1
    };
  }

  render() {
    const {
      dsa,
      area,
      subAreas,
      configuredItems,
      dsaConfiguredItems,
      updateConfiguredItem,
      changeConfiguredItem,
      createCustomConfiguredItem,
      makeOpenContributedCorrelationModal,
      closeContributedCorrelationModal,
      isContributedCorrelationModalOpen,
      canEditEstimatedLogSize,
      canEditPercentItemsIndexed,
      canEditPercentDataSourcesIndexed,
      canViewTotalIndexed,
      dsaExtensions
    } = this.props;

    const {selectedSubArea} = this.state;
    const subareas = subAreas
      .filter(sa => sa.area === area.id)
      .sort((a, b) => a.order - b.order);
    const toggleSubArea = sa => {
      this.setState({
        selectedSubArea: (selectedSubArea !== sa) ? sa : -1
      });
    };

    let hasDSASecurityExtension = false;

    if (
      dsaExtensions &&
      dsaExtensions.length &&
      dsaExtensions[0].active === true &&
      dsaExtensions[0].extension.key === 'dsa.extension.security'
    ) {
      hasDSASecurityExtension = true;
    }

    return (
      <div className='sources-stack'>
        {
          subareas && subareas.map(subarea =>
            (<SourcesStackItem
              dsa={dsa}
              key={subarea.id}
              active={selectedSubArea === subarea.id}
              area={area}
              subarea={subarea}
              canEditEstimatedLogSize={canEditEstimatedLogSize}
              canEditPercentItemsIndexed={canEditPercentItemsIndexed}
              canEditPercentDataSourcesIndexed={canEditPercentDataSourcesIndexed}
              canViewTotalIndexed={canViewTotalIndexed}
              configuredItems={configuredItems}
              dsaConfiguredItems={dsaConfiguredItems}
              updateConfiguredItem={updateConfiguredItem}
              changeConfiguredItem={changeConfiguredItem}
              createCustomConfiguredItem={createCustomConfiguredItem}
              makeOpenContributedCorrelationModal={makeOpenContributedCorrelationModal}
              closeContributedCorrelationModal={closeContributedCorrelationModal}
              isContributedCorrelationModalOpen={isContributedCorrelationModalOpen}
              toggleSubArea={toggleSubArea}
              hasDSASecurityExtension={hasDSASecurityExtension}
            />)
          )
        }
      </div>
    );
  }
}

SourcesStack.propTypes = {
  dsa: PropTypes.object,
  area: PropTypes.object,
  subAreas: PropTypes.array,
  configuredItems: PropTypes.array,
  dsaConfiguredItems: PropTypes.array,
  updateConfiguredItem: PropTypes.func,
  changeConfiguredItem: PropTypes.func,
  createCustomConfiguredItem: PropTypes.func,
  makeOpenContributedCorrelationModal: PropTypes.func,
  closeContributedCorrelationModal: PropTypes.func,
  isContributedCorrelationModalOpen: PropTypes.func,
  canEditEstimatedLogSize: PropTypes.bool,
  canEditPercentItemsIndexed: PropTypes.bool,
  canEditPercentDataSourcesIndexed: PropTypes.bool,
  canViewTotalIndexed: PropTypes.bool,
  dsaExtensions: PropTypes.array
};

export default SourcesStack;



// WEBPACK FOOTER //
// ./src/containers/sources/SourcesStack.js